import { useEffect, useRef } from "react"
import { useAnalytics } from "connected-components/analytics"
import { SelectedMode } from "../../helpers"
import { DASHBOARD_EVENTS } from "../events"

export function useModeChangeTracking(selectedMode: SelectedMode) {
  const analytics = useAnalytics()
  const previousMode = useRef<SelectedMode | undefined>(undefined)

  useEffect(() => {
    if (selectedMode && selectedMode !== previousMode.current) {
      analytics.track(DASHBOARD_EVENTS.MODE_CHANGED, {
        oldMode: previousMode.current,
        newMode: selectedMode,
      })
      previousMode.current = selectedMode
    }
  }, [analytics, selectedMode])
}
